import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './assets/styles/bootstrap.custom.css';
import './assets/styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux';
import store from './store';
import {createBrowserRouter, createRoutesFromElements, Route, RouterProvider} from 'react-router-dom';
import HomeScreen from './screens/HomeScreen';
import SiteScreen from './screens/SiteScreen';
import ProblemScreen from './screens/ProblemScreen';
import SiteDetailScreen from './screens/SiteDetailScreen';
import AddSiteScreen from './screens/AddSiteScreen';
import ReportScreen from './screens/ReportScreen';
import LoginScreen from './screens/LoginScreen';
import ProfileScreen from './screens/ProfileScreen';
import RepScreen from './screens/RepScreen'
import AdminUsersScreen from './screens/AdminUsersScreen';
import InfrastructureStatusScreen from './screens/InfrastructureStatusScreen';
import NetworkScanScreen from './screens/NetworkScanScreen';
import TicketsScreen from './screens/TicketsScreen';
import DmsScreen from './screens/DmsScreen';
import OnboardingScreen from './screens/OnboardingScreen';
import OnboardingPdfScreen from './screens/OnboardingPdfScreen';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route index={true} path="/" element={<HomeScreen />}/>
      <Route path="sites" element={<SiteScreen/>}/>
      <Route path="sites/add" element={<AddSiteScreen/>}/>
      <Route path="problems" element={<ProblemScreen/>}/>
      <Route path='/sites/:id' element={<SiteDetailScreen/>}/>
      <Route path="/login" element={<LoginScreen/>}/>
      <Route path="/profile" element={<ProfileScreen/>}/>
      <Route path="/reports" element={<ReportScreen/>}/>
      <Route path="reps" element={<RepScreen/>}/>
      <Route path="/admin/users" element={<AdminUsersScreen/>}/>
      <Route path="/infrastructure" element={<InfrastructureStatusScreen/>}/>
      <Route path="/network-scan" element={<NetworkScanScreen/>}/>
      <Route path="/tickets" element={<TicketsScreen/>}/>
      <Route path="/dms" element={<DmsScreen/>}/>
      <Route path="/onboarding/:token" element={<OnboardingScreen/>}/>
      <Route path="/onboarding/:token/pdf" element={<OnboardingPdfScreen/>}/>
    </Route>
  )
)

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router}/>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
